import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getSettingsList,
	addNewSettings,
	updateSettings,
	deleteSettings,
	getSettings,
	baseSettingsColor,
	baseSettingsLogin,
	baseSettingsHeader,
	getModulesList,
	getModule,
	addNewModule,
	updateModule,
	deleteModule,
	getModuleEstablishmentList,
	addNewModuleEstablishment,
	updateModuleEstablishment,
	deleteModuleEstablishment,
	getModuleEstablishment,
	getModuleUsageFactList,
} from '../settings/thunk';

export const initialState = {
	itemSettingsList: [],
	itemSettingsDetail: null,
	isSettingsLoading: false,
	isSettingsSuccess: false,

	itemSettingsColor: null,
	itemSettingsLogin: null,
	itemSettingsHeader: null,


	isSettingsLogin: false,
	isSettingsHeader: false,

	settingsList: [],
	settingsListSelect: [],
	getModulesList: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	
	itemModuleEstablishmentList: [],
	itemModuleEstablishmentDetail: null,
	isModuleEstablishmentLoading: false,
	isModuleEstablishmentSuccess: false,
	moduleEstablishmentList: [],
	moduleEstablishmentListSelect: [],
	moduleUsageFactList: [],
	isModuleUsageFactLoading: false,
	
	urlToRedirect: null,
	requireInitRedirect: false,
	currentItemsMenu: []
};

const SettingsSlice = createSlice({
	name: 'Settings',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
		setCurrentItemsMenu(state , action) {
			state.currentItemsMenu = JSON.parse(action.payload) || [];
		},
		setRequireInitRedirect(state, action) {
			state.requireInitRedirect = action.payload;
		},
		setUrlToRedirect(state, action) {
			state.urlToRedirect = action.payload;
		}
	},
	extraReducers: builder => {
		builder.addCase(getSettings.fulfilled, (state, action) => {
			state.isSettingsLoading = false;
			state.isSettingsSuccess = true;
			state.itemSettingsDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getSettings.pending, state => {
			state.isSettingsLoading = true;
			state.isSettingsSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getSettings.rejected, (state, action) => {
			state.isSettingsLoading = false;
			state.isSettingsSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getSettingsList.pending, state => {
			state.isSettingsSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getSettingsList.fulfilled, (state, action) => {
			state.itemSettingsList = action.payload;
			state.settingsList = action.payload;
			state.isLoadingList = false;
			state.isSettingsSuccess = true;

			let settingsListSelect = [];
			action.payload.map(item =>
				settingsListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.settingsListSelect = settingsListSelect;
		});
		builder.addCase(getSettingsList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isSettingsSuccess = true;
		});
		builder.addCase(addNewSettings.fulfilled, (state, action) => {
			state.itemSettingsList.push(action.payload);
			state.settingsList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewSettings.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewSettings.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateSettings.fulfilled, (state, action) => {
			state.itemSettingsList = state.itemSettingsList.map(settings =>
				settings.settingsname === action.payload.old_settings
					? { ...settings, ...action.payload.updated_settings }
					: settings
			);
			state.settingsList = state.settingsList.map(settings =>
				settings._id.toString() === action.payload._id.toString()
					? { ...settings, ...action.payload }
					: settings
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateSettings.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateSettings.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteSettings.fulfilled, (state, action) => {
			state.itemSettingsList = current(state.itemSettingsList).filter(
				item => item._id !== action.payload._id
			);
			state.settingsList = current(state.settingsList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteSettings.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteSettings.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});



		builder.addCase(baseSettingsColor.fulfilled, (state, action) => {
			state.isSettingsLoading = false;
			state.isSettingsSuccess = true;
			state.itemSettingsColor = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(baseSettingsColor.pending, state => {
			state.isSettingsLoading = true;
			state.isSettingsSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(baseSettingsColor.rejected, (state, action) => {
			state.isSettingsLoading = false;
			state.isSettingsSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});



		builder.addCase(baseSettingsLogin.fulfilled, (state, action) => {
			state.isSettingsLogin = false;
			state.itemSettingsLogin = action.payload;
		});
		builder.addCase(baseSettingsLogin.pending, state => {
			state.isSettingsLogin = true;
		});
		builder.addCase(baseSettingsLogin.rejected, (state, action) => {
			state.isSettingsLogin = false;
			state.error = action.error.message;
		});



		builder.addCase(baseSettingsHeader.fulfilled, (state, action) => {
			state.isSettingsHeader = false;
			state.itemSettingsHeader = action.payload;
		});
		builder.addCase(baseSettingsHeader.pending, state => {
			state.isSettingsHeader = true;
		});
		builder.addCase(baseSettingsHeader.rejected, (state, action) => {
			state.isSettingsHeader = false;
			state.error = action.error.message;
		});




		builder.addCase(getModulesList.pending, state => {
			state.isSettingsSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getModulesList.fulfilled, (state, action) => {
			state.getModulesList = action.payload;
			state.settingsList = action.payload;
			state.isLoadingList = false;
			state.isSettingsSuccess = true;

			let settingsListSelect = [];
			action.payload.map(item =>
				settingsListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.settingsListSelect = settingsListSelect;
		});
		builder.addCase(getModulesList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isSettingsSuccess = true;
		});

		builder.addCase(getModule.fulfilled, (state, action) => {
			state.isLoadingList = false;
			state.isSettingsSuccess = true;
			state.moduleDetail = action.payload;
		});
		builder.addCase(getModule.pending, state => {
			state.isLoadingList = true;
			state.isSettingsSuccess = null;
			state.error = null;
		});
		builder.addCase(getModule.rejected, (state, action) => {
			state.isLoadingList = false;
			state.isSettingsSuccess = false;
			state.error = action.error.message;
		});

		builder.addCase(addNewModule.fulfilled, (state, action) => {
			state.getModulesList.push(action.payload);
			state.settingsList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewModule.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewModule.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateModule.fulfilled, (state, action) => {
			state.getModulesList = state.getModulesList.map(module =>
				module._id.toString() === action.payload._id.toString()
					? { ...module, ...action.payload }
					: module
			);
			state.settingsList = state.settingsList.map(module =>
				module._id.toString() === action.payload._id.toString()
					? { ...module, ...action.payload }
					: module
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateModule.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateModule.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteModule.fulfilled, (state, action) => {
			state.getModulesList = current(state.getModulesList).filter(
				item => item._id !== action.payload._id
			);
			state.settingsList = current(state.settingsList).filter(
				item => item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDeleteError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteModule.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});
		builder.addCase(deleteModule.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDeleteError = true;
		});

		builder.addCase(getModuleEstablishment.fulfilled, (state, action) => {
			state.isModuleEstablishmentLoading = false;
			state.isModuleEstablishmentSuccess = true;
			state.itemModuleEstablishmentDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getModuleEstablishment.pending, state => {
			state.isModuleEstablishmentLoading = true;
			state.isModuleEstablishmentSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getModuleEstablishment.rejected, (state, action) => {
			state.isModuleEstablishmentLoading = false;
			state.isModuleEstablishmentSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getModuleEstablishmentList.pending, state => {
			state.isModuleEstablishmentSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getModuleEstablishmentList.fulfilled, (state, action) => {
			state.itemModuleEstablishmentList = action.payload;
			state.moduleEstablishmentList = action.payload;
			state.isLoadingList = false;
			state.isModuleEstablishmentSuccess = true;

			let moduleEstablishmentListSelect = [];
			action.payload.map(item =>
				moduleEstablishmentListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.moduleEstablishmentListSelect = moduleEstablishmentListSelect;
		});
		builder.addCase(getModuleEstablishmentList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isModuleEstablishmentSuccess = true;
		});
		builder.addCase(addNewModuleEstablishment.fulfilled, (state, action) => {
			state.itemModuleEstablishmentList.push(action.payload);
			state.moduleEstablishmentList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewModuleEstablishment.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewModuleEstablishment.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateModuleEstablishment.fulfilled, (state, action) => {
			state.itemModuleEstablishmentList = state.itemModuleEstablishmentList.map(moduleEstablishment =>
				moduleEstablishment.moduleEstablishmentname === action.payload.old_moduleEstablishment
					? { ...moduleEstablishment, ...action.payload.updated_moduleEstablishment }
					: moduleEstablishment
			);
			state.moduleEstablishmentList = state.moduleEstablishmentList.map(moduleEstablishment =>
				moduleEstablishment._id.toString() === action.payload._id.toString()
					? { ...moduleEstablishment, ...action.payload }
					: moduleEstablishment
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateModuleEstablishment.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateModuleEstablishment.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteModuleEstablishment.fulfilled, (state, action) => {
			state.itemModuleEstablishmentList = current(state.itemModuleEstablishmentList).filter(
				item => item._id !== action.payload._id
			);
			state.moduleEstablishmentList = current(state.moduleEstablishmentList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteModuleEstablishment.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteModuleEstablishment.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});

		builder.addCase(getModuleUsageFactList.pending, state => {
			state.isModuleUsageFactLoading = true;
			state.error = null;
		});
		builder.addCase(getModuleUsageFactList.fulfilled, (state, action) => {
			state.moduleUsageFactList = Array.isArray(action.payload)
				? action.payload
				: [];
			state.isModuleUsageFactLoading = false;
		});
		builder.addCase(getModuleUsageFactList.rejected, (state, action) => {
			state.moduleUsageFactList = [];
			state.isModuleUsageFactLoading = false;
			state.error = action.error.message;
		});
	},
});

export const {
	setRequireCloseModal,
	setCurrentItemsMenu,
	setRequireInitRedirect,
	setUrlToRedirect
} = SettingsSlice.actions;

export default SettingsSlice.reducer;